import md5 from '@/helpers/md5'

export const vueAppTitle = process.env.VUE_APP_TITLE
export const socketIoHost = process.env.VUE_APP_SOCKET_IO_HOST
export const socketIoPath = process.env.VUE_APP_SOCKET_IO_PATH
export const iframeHost = process.env.VUE_APP_IFRAME_HOST
export const authPassword = process.env.VUE_APP_USER_AUTHENTICATION_PASSWORD
export const botFirstMessage = ['Wie kann ich Ihnen helfen?']

export const showSystemMessages =
  process.env.VUE_APP_SHOW_SYSTEM_MESSAGES === '1'

export const disableMessagesDelay =
  process.env.VUE_APP_DISABLE_MESSAGES_DELAY === '1'

// boolean flags need to be exported directly and compared later
// otherwise npm build will compile them, which leads to not being
// able to set it during deployment
export const enableIframeOption = process.env.VUE_APP_ENABLE_IFRAME_OPTION

export const enableShowFeedbackPrompt =
  process.env.VUE_APP_ENABLE_SHOW_FEEDBACK_PROMPT

export const disableKeycloakAuthorization = process.env.VUE_APP_DISABLE_KEYCLOAK

export const socketIoSubpathRouting =
  process.env.VUE_APP_SOCKET_IO_HOST_SUBPATH_ROUTING

export const enableLiveChatBot =
  process.env.VUE_APP_LIVE_CHAT_BOT_OPTION === '1'

export const dashboardUrl = process.env.VUE_APP_DASHBOARD_URL

let urlParams = new URLSearchParams(window.location.search)

export const isPreviewMode = (urlParams.get('mode') || 'default') === 'preview'
export const conversationId = urlParams.get('conversation_id')
export const createdBy = urlParams.get('created_by')
export const availableLanguages = process.env.VUE_APP_ENABLE_LOCALES.split(',')

const iframeDefaultLocale = urlParams.get('default_language')
export const iframeAvailableLocales = urlParams.get('available_languages')
  ? urlParams.get('available_languages').split(',')
  : null

export const showFullScreen = urlParams.get('fullscreen') === 'true'

export const privacyAgreementAccepted = urlParams.get(
  'privacy_agreement_accepted'
)
  ? JSON.parse(urlParams.get('privacy_agreement_accepted'))
  : true

export const parentUrlParam = urlParams.get('url')
  ? decodeURIComponent(urlParams.get('url'))
  : ''

export const initializedFromScript = urlParams.get('from_script')
  ? urlParams.get('from_script')
  : false

export const startConversationUrlParam = urlParams.get('start_conversation')
  ? urlParams.get('start_conversation')
  : ''

export const tenantId = urlParams.get('tenant_id')
export const contractId = urlParams.get('contract_id')
export const email = urlParams.get('email')
export const birthDate = urlParams.get('birth_date')
export const referenceTenant = urlParams.get('reference_tenant')
export const tenantHash = md5(
  `${tenantId}${contractId}${email}${birthDate}${referenceTenant}`
)

export const estateId = urlParams.get('estate_id')

export const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
)

export const agentHost = language => {
  if (isLocalhost) {
    return socketIoHost
  }

  return socketIoSubpathRouting === '1'
    ? `${socketIoHost}/agent/${language}`
    : socketIoHost.startsWith('http')
    ? `${socketIoHost}`.replace(/http(s?):\/\//, `http$1://${language}-`)
    : `${language}-${socketIoHost}`
}

export const maximumFileUploadCount = 5

/**
 * get the default locale from cookie, .env or URL param and check that is
 * in available_languages, return first available language if not
 * @returns {string}
 */
function getDefaultLocale() {
  let locale
  if (navigator.cookieEnabled) {
    locale =
      localStorage.getItem('localeLanguage') ||
      iframeDefaultLocale ||
      process.env.VUE_APP_DEFAULT_LOCALE
  } else {
    locale = iframeDefaultLocale || process.env.VUE_APP_DEFAULT_LOCALE
  }
  if (iframeAvailableLocales && !iframeAvailableLocales.includes(locale)) {
    return iframeAvailableLocales[0]
  } else {
    return locale
  }
}

export const defaultLocale = getDefaultLocale()

if (navigator.cookieEnabled) {
  const storage = navigator.cookieEnabled ? localStorage : sessionStorage
  // Check if user has cookies allowed

  const storedLocaleLanguage = storage.getItem('localeLanguage')

  if (!storedLocaleLanguage) {
    localStorage.setItem('localeLanguage', defaultLocale)
  }

  const storedLocale = localStorage.getItem('locale')
  if (!storedLocale) {
    localStorage.setItem('locale', defaultLocale.toLowerCase().substring(0, 2))
  }
}

export const parentOriginHost = process.env.VUE_APP_PARENT_ORIGIN

export const themeName = process.env.VUE_APP_THEME_NAME

export const s3EndpointUrl = process.env.VUE_APP_S3_ENDPOINT_URL
export const s3BucketName = process.env.VUE_APP_S3_BUCKET_NAME
export const s3BucketPrefix = process.env.VUE_APP_S3_BUCKET_NAMESPACE

export const keycloakConfig = {
  authRealm: process.env.VUE_APP_KEYCLOAK_REALM,
  authUrl: process.env.VUE_APP_KEYCLOAK_URL,
  authClientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
}

export const unleashEnabled = process.env.VUE_APP_UNLEASH_ENABLED
export const unleashConfig = {
  url: process.env.VUE_APP_UNLEASH_URL,
  clientKey: 'some_secret',
  appName: 'chatplugin'
}

export default {
  vueAppTitle,
  socketIoHost,
  socketIoPath,
  defaultLocale,
  showSystemMessages,
  botFirstMessage,
  authPassword,
  disableMessagesDelay,
  enableIframeOption,
  iframeHost,
  parentOriginHost
}
